import { Component, Input } from '@angular/core';
import { Patient } from '../../../models/patient';
import { TraitementDataComponent } from "../traitement-data/traitement-data.component";
import { ALaDateDuPipe } from '../../../pipes/a-la-date-du.pipe';

@Component({
  selector: 'app-traitement-data-epap-min-max',
  standalone: true,
  imports: [TraitementDataComponent, ALaDateDuPipe],
  templateUrl: './traitement-data-epap-min-max.component.html',
  styleUrl: './traitement-data-epap-min-max.component.scss'
})
export class TraitementDataEpapMinMaxComponent {
  @Input() patient: Patient | undefined;
}
